import React, { useEffect, useState } from 'react'
import Header from '../../../Header/Header'
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading'
import * as jnb from 'react-bootstrap';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import { CommonAxiosGet } from '../../../CommonUtils/CommonAxios/CommonAxios';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaEdit, FaHandPointRight } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { CommonReactTable } from '../../../CommonUtils/CommonTable/CommonReactTable';
import { ImCross } from 'react-icons/im';
import { GiCheckMark } from 'react-icons/gi';
import { CgDanger } from 'react-icons/cg';
import Sweetalert from '../../../CommonUtils/CommonPopupAndAlerts/SweetAlerts';

export default function WorkerRegistrationReport() {

    const loginreducer = useSelector((state) => state?.reducers?.loginreducer?.loginDetails?.loginData);
    const [showList, setList] = useState([])
    const [showlevel, setlevel] = useState(0);
    let location = useLocation()
    let alo_org = location?.state?.alo_org
    function GetChequeInReport() {
        let url = config.url.BOC_URL + "worker-reg-report-alo";
        //let url = config.url.BOC_URL + "mandalWise?alo_org=" + alo_org;
        CommonAxiosGet(url).then((response) => {
            if (response.data.status === true) {
                setList(response.data.WorkerRegReport);
                setlevel(0)
                console.log(response.data.WorkerRegReport[0].alo_total)
            }
            else {
                Sweetalert(response.data.sdesc, 'error');
                setList([])

            }
        })
    }
    const columns = [
        {
            Header: 'S.NO',
            accessor: (row, index) => index + 1,
            Footer: 'Total',
        },
        {
            Header: 'Mandal',

            accessor: "mandal_name",
        },
        {
            Header: 'Registered on their Own',
            columns: [
                {
                    Header: () => (<FaEdit size={19} color='blue' />),
                    accessor: "own_total",
                    Cell: ({ row }) => (
                        <span
                            style={{ color: 'Highlight', textDecoration: 'underline', cursor: 'pointer' }}
                            onClick={() => {
                                if (row?.original?.own_total === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "own_total" } });
                                }
                            }}
                        >
                            {row?.original?.own_total}
                        </span>
                    ),
                    Footer: 'own_total',
                    tooltipmsg: 'Received'
                },

                {
                    Header: () => (<GiCheckMark size={25} color='green' />),
                    accessor: "own_approved",
                    Cell: ({ row }) => <span style={{ color: 'Highlight', textDecoration: 'underline' }} 
                  //  onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "own_approved" } }) }}>
                   onClick={() => {
                                if (row?.original?.own_approved === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "own_approved" } });
                                }
                            }}
                        >
                        {row?.original?.own_approved}</span>,
                    Footer: 'own_approved',
                    tooltipmsg: 'Approved'
                },
                {
                    Header: () => (<ImCross size={17} color='red' />),
                    accessor: "own_rejected",
                    Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} 
                        //onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "own_rejected" } }) }}>
                           onClick={() => {
                                if (row?.original?.own_rejected === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "own_rejected" } });
                                }
                            }}
                        >
                            {row?.original?.own_rejected}</span>),
                    Footer: 'own_rejected',
                    tooltipmsg: 'Rejected'
                },
                {
                    Header: () => (<CgDanger size={24} color='#cf7b06' />),
                    accessor: "own_pending",
                    Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} 
                       // onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "own_pending" } }) }}>
                        onClick={() => {
                                if (row?.original?.own_pending === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "own_pending" } });
                                }
                            }}
                        >
                            {row?.original?.own_pending}</span>),
                    Footer: 'own_pending',
                    tooltipmsg: 'Pending'
                },
            ],  
        },
        {
            Header: 'Registered By GSWS',
            // accessor: 'Registered By GSWS',
            columns: [
                {
                    Header: () => (<FaEdit size={19} color='blue' />),
                    accessor: "gsws_total",
                    Cell: ({ row }) => <span style={{ color: 'Highlight', textDecoration: 'underline' }}
                   //  onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "gsws_total" } }) }}>

                    onClick={() => {
                                if (row?.original?.gsws_total === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "gsws_total" } });
                                }
                            }}
                        >
                        {row?.original?.gsws_total} </span>,
                    Footer: 'gsws_total',
                    tooltipmsg: 'Received'
                },

                {
                    Header: () => (<GiCheckMark size={25} color='green' />),
                    accessor: "gsws_approved",
                    Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} 
                      //  onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "gsws_approved" } }) }}>
                      onClick={() => {
                                if (row?.original?.gsws_approved === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "gsws_approved" } });
                                }
                            }}
                        >
                            {row?.original?.gsws_approved} </span>),
                    Footer: 'gsws_approved',
                    tooltipmsg: 'Approved'

                },
                {
                    Header: () => (<ImCross size={17} color='red' />),
                    accessor: "gsws_rejected",
                    Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} 
                      //  onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "gsws_rejected" } }) }}>
                      onClick={() => {
                                if (row?.original?.gsws_rejected === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "gsws_rejected" } });
                                }
                            }}
                        >
                            {row?.original?.gsws_rejected} </span>),
                    Footer: 'gsws_rejected',
                    tooltipmsg: 'Rejected'

                },
                {
                    Header: () => (<CgDanger size={24} color='#cf7b06' />),
                    accessor: "gsws_pending",
                    Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }}
                        // onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "gsws_pending" } }) }}>
                        onClick={() => {
                                if (row?.original?.gsws_pending === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "gsws_pending" } });
                                }
                            }}
                        >
                            {row?.original?.gsws_pending} </span>),
                    Footer: 'gsws_pending',
                    tooltipmsg: 'Pending'

                },
            ],
            Footer: '',
        },
        {
            Header: 'Registered By Me',
            columns: [
                {
                    Header: () => (<FaEdit size={19} color='blue' />),
                    accessor: "alo_total",
                    Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} 
                        //onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "alo_total" } }) }}>
                        onClick={() => {
                                if (row?.original?.alo_total === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "alo_total" } });
                                }
                            }}
                        >
                            {row?.original?.alo_total} </span>),
                    Footer: 'alo_total',
                    tooltipmsg: 'Received'

                },
                {
                    Header: () => (<GiCheckMark size={25} color='green' />),
                    accessor: "alo_approved",
                    Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} 
                       // onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "alo_approved" } }) }}>
                       onClick={() => {
                                if (row?.original?.alo_approved === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "alo_approved" } });
                                }
                            }}
                        >
                            {row?.original?.alo_approved} </span>),
                    Footer: 'alo_approved',
                    tooltipmsg: 'Approved'
                },
                {
                    Header: () => (<ImCross size={17} color='red' />),
                    accessor: "alo_rejected",
                    Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }}
                        // onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "alo_rejected" } }) }}>
                        onClick={() => {
                                if (row?.original?.alo_rejected === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "alo_rejected" } });
                                }
                            }}
                        >
                            {row?.original?.alo_rejected} </span>),
                    Footer: 'alo_rejected',
                    tooltipmsg: 'Rejected'
                },
                {
                    Header: () => (<CgDanger size={24} color='#cf7b06' />),
                    accessor: "alo_pending",
                    Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} 
                        //onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "alo_pending" } }) }}>
                          onClick={() => {
                                if (row?.original?.alo_pending === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "alo_pending" } });
                                }
                            }}
                        >
                            {row?.original?.alo_pending}  </span>),
                    Footer: 'alo_pending',
                    tooltipmsg: 'Pending'
                },
            ],
            Footer: '',
        },
        {
            Header: 'Total',
            columns: [
                {
                    Header: () => (<FaEdit size={19} color='blue' />),
                    accessor: "total",
                    Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} 
                  //      onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "total", alo_org: row?.alo_org } }) }}>
                   onClick={() => {
                                if (row?.original?.total === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "total", alo_org: row?.alo_org } }) 
                                }
                            }}
                        >
                            {row?.original?.total} </span>),
                    Footer: 'total',
                    tooltipmsg: 'Received'
                },
                {
                    Header: () => (<GiCheckMark size={25} color='green' />),
                    accessor: "approved",
                    Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} 
                      //  onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "approved", alo_org: row?.alo_org } }) }}>
                      onClick={() => {
                                if (row?.original?.approved === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "approved", alo_org: row?.alo_org } }) 
                                }
                            }}
                        >
                            {row?.original?.approved} </span>),
                    Footer: 'approved',
                    tooltipmsg: 'Approved'
                },
                {
                    Header: () => (<ImCross size={17} color='red' />),
                    accessor: "rejected",
                    Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} 
                      //  onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "rejected", alo_org: row?.alo_org } }) }}>
                       onClick={() => {
                                if (row?.original?.rejected === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "rejected", alo_org: row?.alo_org } }) 
                                }
                            }}
                        >
                            {row?.original?.rejected} </span>),
                    Footer: 'rejected',
                    tooltipmsg: 'Rejected'
                },
                {
                    Header: () => (<CgDanger size={24} color='#cf7b06' />),
                    accessor: "pending",
                    Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }}
                        // onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "pending", alo_org: row?.alo_org } }) }}>
                         onClick={() => {
                                if (row?.original?.pending === 0) {
                                    Sweetalert("No Data Found", "error");
                                } else {
                                    navigate('/WorkerRegistrationReport2', { state: { status: "pending", alo_org: row?.alo_org } }) 
                                }
                            }}
                        >
                            {row?.original?.pending}  </span>),
                    Footer: 'pending',
                    tooltipmsg: 'Pending'
                },
            ],
            Footer: '',
        },
    ]
    useEffect(() => { GetChequeInReport() }, [])
    let navigate = useNavigate()
    return (
        <React.Fragment>
            <Header />
            <div className="main_section"> </div>
            {/* <CommonPageHeading heading="Worker Registration Report" /> */}
              <jnb.Container className="mt-1">
                                            <jnb.Row>
                                                          <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing d-flex justify-content-between px-0">
                                        <div className="inner-herbpage-service-title1">
                                                                <h1>Registration Form for Workers(కార్మికుల కోసం నమోదు ఫారం)</h1>
                                                            </div>
                                                              <div className="text-right">
                                <button className="btn btn-secondary btn-sm"  onClick={() => {
                        
                          navigate('/Dashboard');
                        
                      }}>Back</button>
                                </div>
                                                            </jnb.Col>
                                                            </jnb.Row>
                                                            </jnb.Container>
            <jnb.Container className="outer-page-content-container">
                <div className="px-2 mt-1 text-right" onClick={() => navigate("/WorkerRegistrationForm", { state: { status: "ALO", username: loginreducer?.username } })}>
                    <FaHandPointRight size={25} color='#ffb366'></FaHandPointRight> &nbsp;
                    <i className="badge badge-success forgot mb-1 fw-bold " data-toggle="tooltip" animation="true" title="Registration For Workers!"
                    > New Registration</i>
                </div>
                {showList.length > 0 && showlevel === 0 && (
                    <div className="table-responsive">
                        {/* <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                        style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', backgroundColor: "#cfe2ff" }}
                    >
                        <thead >
                            <tr>
                                <th rowSpan={3}>S.NO</th>
                                <th rowSpan={3}>Mandal</th>
                                <th colSpan={4}>Registered on their Own</th>
                                <th colSpan={4}>Registered By GSWS</th>
                                <th colSpan={4}>Registered By Me</th>

                            </tr>
                            <tr>
                                <th rowSpan={2}>Registered</th>
                                <th colSpan={3}>Verified</th>
                                <th rowSpan={3}>Registered</th>
                                <th colSpan={3}>Verified</th>
                                <th rowSpan={3}>Registered</th>
                                <th colSpan={3}>Verified</th>
                            </tr>
                            <tr>
                                <th>Approved</th>
                                <th>Rejected</th>
                                <th>Pending</th>
                                <th>Approved</th>
                                <th>Rejected</th>
                                <th>Pending</th>
                                <th>Approved</th>
                                <th>Rejected</th>
                                <th>Pending</th>
                            </tr>
                        </thead>
                        <tbody>
                            {showList?.map((data, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{data?.mandal_name}</td>
                                        <td style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "own_total" } }) }}>{data?.own_total}</td>
                                        <td style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "own_approved" } }) }}>{data?.own_approved}</td>
                                        <td style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "own_rejected" } }) }}>{data?.own_rejected}</td>
                                        <td style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "own_pending" } }) }}>{data?.own_pending}</td>
                                        <td style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "gsws_total" } }) }}>{data?.gsws_total}</td>
                                        <td style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "gsws_approved" } }) }}>{data?.gsws_approved}</td>
                                        <td style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "gsws_rejected" } }) }}>{data?.gsws_rejected}</td>
                                        <td style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "gsws_pending" } }) }}>{data?.gsws_pending}</td>
                                        <td style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "alo_total" } }) }}>{data?.alo_total}</td>
                                        <td style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "alo_approved" } }) }}>{data?.alo_approved}</td>
                                        <td style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "alo_rejected" } }) }}>{data?.alo_rejected}</td>
                                        <td style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport2', { state: { status: "alo_pending" } }) }}>{data?.alo_pending}</td>
                                    </tr>
                                )
                            })}
                        </tbody>

                    </table> */}
                        <CommonReactTable columns={columns} data={showList} showFooter="true" filename="DepartmentReport" />
                    </div>
                )}
            </jnb.Container>
        </React.Fragment>

    )
}
